<template>
  <PaginationWrapper
    :page="page"
    :totalCount="totalCount"
    @onPageChange="handlePageChange"
    export
    @exportTable="exportList"
  >
    <GuaranteesSearchOptions @onSearch="handleSearch" slot="search-options" />
    <GuaranteesListTable slot="table" />
  </PaginationWrapper>
</template>

<script>
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import GuaranteesListTable from '@/components/sections/pnf/GuaranteesListTable';
import GuaranteesSearchOptions from '@/components/sections/pnf/GuaranteesSearchOptions';

export default {
  name: 'Guarantees',
  components: {
    PaginationWrapper,
    GuaranteesListTable,
    GuaranteesSearchOptions,
  },
  data() {
    return {
      query: {},
      page: 1,
      totalCount: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      this.totalCount = await this.$store.dispatch('storeActualGuarantees', {
        query: this.query,
        page: this.page,
      });
      this.$store.dispatch('storeLoading', false);
    },
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: this.query,
          type: 'actualGuarantees',
        });
        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', { type: 'actualGuarantees' }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `actualGuarantees-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'actualGuarantees' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'actualGuarantees' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
